<template>
  <form class="usuarioForm row wrap align-center" onsubmit="return false" @submit="send">
    <div class="grid-3 grid-12-s">
      <label>Operação</label><br />
      <select v-model="form.id_operacao">
        <option>SELECIONE</option>
        <option v-for="o of operacoes" :value="o.id" :key="o.id">{{ o.nome }}</option>
      </select>
    </div>
    <div class="grid-3 grid-12-s">
      <label>Nome</label><br />
      <input v-model="form.nome" placeholder="Nome" />
    </div>
    <div class="grid-3 grid-12-s">
      <label>E-mail</label><br />
      <input type="email" v-model="form.login" placeholder="E-mail" />
    </div>
    <Button type="submit" :loader="loader" layout="green-go"><i class="fa fa-edit" />{{ usuario ? "ATUALIZAR" :
      "ADICIONAR" }}</Button>
    <Button v-if="usuario && usuario.status == 'ativo'" type="button" @click="del" :loader="loader" layout="red-go"><i
        class="fa fa-trash" /> DESATIVAR</Button>
    <Button v-if="usuario && usuario.status == 'inativo'" type="button" @click="activate" :loader="loader"
      layout="green-go white"><i class="fa fa-check" /> ATIVAR</Button>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import format from '@/utils/format'

export default {
  name: "UsuarioForm",
  components: { Button },
  props: { usuario: Object, reload: Function, client: Number, operacoes: Array },
  data() {
    return {
      loader: false,
      form: { id_operacao: "",  },
    };
  },
  methods: {
    ...mapActions("admin", ["CLIENT_USUARIO", "CLIENT_USUARIO_ACTIVE"]),
    async send() {
      this.loader = true;
      let data = { ...this.form, ID: this.client }
      data.fone_responsavel = format.clear(data.fone_responsavel)
      data.t = this.usuario ? 'put' : 'post'
      await this.CLIENT_USUARIO(data)
      this.loader = false;
      this.reload()
    },
    async activate() {
      this.loader = true
      await this.CLIENT_USUARIO_ACTIVE({ ID: this.client, id: this.form.id })
      this.loader = false;
      this.reload()
    },
    async del() {
      if (confirm(`Deseja desativar este usuário: ${this.form.nome}?`)) {
        this.loader = true;
        await this.CLIENT_USUARIO({ ID: this.client, id: this.form.id, t: 'delete' })
        this.loader = false
        this.reload()
      }
    },
  },
  beforeMount() {
    if (this.usuario) this.form = this.usuario
  }
};
</script>
<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.usuarioForm
  @include form
  padding: 12px 20px
  border-radius: 12px
  background: #f1f1f8
  @include border
  .grid-3
    margin-bottom: 12px
  .button-red-go, .white
    margin-left: 12px
</style>
